import React, { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { motion, AnimatePresence } from 'framer-motion';
import { colors } from '../../styles/colors';

const ScrollToTopFAB = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isMobile = window.innerWidth < 900;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.3 }}
          style={{
            position: 'fixed',
            bottom: isMobile ? 90 : 30,
            right: 20,
            zIndex: 100,
          }}
        >
          <Fab
            size="small"
            onClick={handleClick}
            aria-label="Retour en haut de page"
            sx={{
              bgcolor: colors.primary,
              color: colors.white,
              boxShadow: '0 4px 16px rgba(27, 94, 64, 0.3)',
              '&:hover': {
                bgcolor: colors.primaryLight,
              },
            }}
          >
            <KeyboardArrowUpIcon />
          </Fab>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTopFAB;
